import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ReportTab {
  id: string; // "overview" | "created-vs-resolved" | custom report UUID
  type: "pinned" | "prebuilt" | "custom";
  label: string;
  route: string; // pre-computed route path (without portalKey — filled at render time)
}

interface ReportTabsState {
  /** Key = portalKey, Value = array of open tabs for that portal */
  tabsByPortal: Record<string, ReportTab[]>;
}

const OVERVIEW_TAB: ReportTab = {
  id: "overview",
  type: "pinned",
  label: "Overview",
  route: "PORTAL_REPORTS", // resolved at render time
};

const initialState: ReportTabsState = {
  tabsByPortal: {},
};

const reportTabsSlice = createSlice({
  name: "reportTabs",
  initialState,
  reducers: {
    openTab(state, action: PayloadAction<{ portalKey: string; tab: ReportTab }>) {
      const { portalKey, tab } = action.payload;
      if (!state.tabsByPortal[portalKey]) {
        state.tabsByPortal[portalKey] = [OVERVIEW_TAB];
      }
      const tabs = state.tabsByPortal[portalKey];
      // Don't add if already open
      if (!tabs.some((t) => t.id === tab.id)) {
        tabs.push(tab);
      }
    },

    closeTab(state, action: PayloadAction<{ portalKey: string; tabId: string }>) {
      const { portalKey, tabId } = action.payload;
      if (!state.tabsByPortal[portalKey]) return;
      // Can't close pinned tabs
      state.tabsByPortal[portalKey] = state.tabsByPortal[portalKey].filter((t) =>
        t.id === tabId ? t.type === "pinned" : true,
      );
    },

    initPortalTabs(state, action: PayloadAction<{ portalKey: string }>) {
      const { portalKey } = action.payload;
      if (!state.tabsByPortal[portalKey]) {
        state.tabsByPortal[portalKey] = [OVERVIEW_TAB];
      }
    },
  },
});

export const { openTab, closeTab, initPortalTabs } = reportTabsSlice.actions;
export default reportTabsSlice.reducer;
